module.exports = __webpack_public_path__ + "img/microsoft-word.0fecf5ec.svg";